import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import AboutPage from '../components/AboutPage';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #ededed;
  min-height: 100vh;
`;

const About = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <SEO 
        title="О турагентстве Максимум Тур | Отзывы, О нас во Владивостоке"
        description="Турагентство Максимум Тур во Владивостоке - профессиональный подбор туров, индивидуальный подход, лучшие цены. Отзывы клиентов, опыт работы и преимущества."
        keywords="о нас, турагентство Максимум Тур, отзывы, турфирма Владивосток, о компании, почему мы, преимущества"
        type="website"
      />
      <Menu />
      <Header />
      <PageHeader />
      <AboutPage />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default About;